export const PATHS = {
  MAIN_PAGE: "/",
  CATALOG_PAGE: "/catalogs",
  EDIT_PAGE: "/editing",
  LOGIN_PAGE: "/login",
  TECHOPERATIONS_PAGE: "/tech-operations",
  OBSERVATIONS_PAGE: "/observations",
};
